import { EntityCalendar } from 'components/mrp/components/Calendar';
import { CalendarRowProps } from 'components/mrp/components/Calendar/Calendar.types';
import CalendarWrapper from 'components/mrp/components/CalendarWrapper/CalendarWrapper';
import { useCalendarStore } from 'components/mrp/stores/calendarStore/calendarStore';
import { memo, useMemo } from 'react';

const CalendarRow = memo(
  ({ calendarId }: CalendarRowProps) => {
    const calendar = useCalendarStore((state) => state.calendars[calendarId]);

    const planningEntityIdentifiers = useMemo(
      () =>
        calendar?.sources.flatMap(
          ({ planningEntityIdentifier }) => planningEntityIdentifier
        ) ?? [],
      [calendar?.sources]
    );

    if (!calendar) return null;

    return (
      <CalendarWrapper displayData={calendar}>
        <EntityCalendar
          calendarId={calendar.calendarId}
          planningEntityIdentifiers={planningEntityIdentifiers}
        />
      </CalendarWrapper>
    );
  },
  (prev, next) => {
    return prev.calendarId === next.calendarId;
  }
);

export default CalendarRow;
